export const MASAN_VO_BINH_CAT_CODE = 'mch_vo_binh';
export const MASAN_SAN_PHAM_CAT_CODE = ['mch_san_pham', 'mch_qua_tang'];

export const LIMIT_ITEM_PER_PAGE_PRODUCT_LIST = 20;

export const TENANT_LIMIT_SEARCH_CAT: { [key: string]: string[] } = {
  'masan-dealer': MASAN_SAN_PHAM_CAT_CODE,
};
